import FeedItem from './feeditem.js';
import { useEffect, useState, useRef, useCallback } from 'react';
import Topstory from './topstory.js';
import useItemsList from './itemslist.js';
import MyLoader from './myjoyloader.js';
//import Album from './album.js';
import { useLocation, Link  } from 'react-router-dom';
//import usePlayList from './useplaylist.js';
import Video from './video.js';
import Customad from './customad.js';
//import GoogleAds from './googleads.js';
//import VideoReel from './videoreel.js';
//import Recommended from './related.js';
//import { useCookies } from 'react-cookie';
import useVideosList from './videolist.js';
import { Helmet } from 'react-helmet';
//import Newstories from './newstories.js';
//import loader from '../loader.gif';
import Chartbeat from './chartbeat.js';
//import Mobilead from './mobilead.js';
import Sectionlead from './sectionlead.js';
//import Recommended from './related.js';

function NewsFeed(match){
    let baseurl = window.location.origin
    const location = useLocation();
    const [categories,setCategories] = useState();
    const [pvcursour, setPvcursour] = useState();
    const [newstories,setNewstories] = useState();
    const [shown, setShown] = useState(false);
    const [page, setPage] = useState(10);
    let ismount = true
    let vindex = -1;
    let pagemeta = ""
  
    let pg = (match.match.url).split("/");
     pagemeta = (pg[1] == "gallery") ? "photo story" : (pg[1] === "newsfeed") ? null: (pg[1] === "") ? null: pg.length === 3 ? pg[2] : pg[1];
    let catnotin = (pagemeta == "obituary") ? "" : "18";
    
    var items_more = 15;
    const { newsitems, error, loading, items, fetchMore , updateQuery} = useItemsList({variables:{ first: 25, after: null, categoryNotIn: catnotin, categoryName: pagemeta}});

   // let stories = items.filter((itm,index)=>items.indexOf(itm)===index);

    //console.log(pagemeta);

    


    useEffect(() => {

    
        if(ismount){
       fetchMore({ variables: {categoryNotIn: catnotin, categoryName: pagemeta, first: 25, after: null },
            updateQuery
          });
    
         // prevNewsitems => {return prevNewsitems, res.data}
        setCategories(pagemeta);

        }

        setPvcursour(newsitems.endCursor)
        items_more = 25;

        //getnewstories();
          

    }, [pagemeta])
    
   

   
    // Get Video
    //let  apikey = "";
    //let channelId = "UChd1DEecCRlxaa0-hvPACCw";
   // const { videoitems, verror, vloading } = usePlayList(channelId, 20, apikey);
    const { videoitems } = useVideosList("UChd1DEecCRlxaa0-hvPACCw", 200, "AIzaSyB8n28NznvwpjKVm57ovejv_0X5GjqAu0U");
    //const {videos, setVideos} =  useState();
    //let vmounted = false

 /* useEffect(()=>{

        if(videoitems.error != true && ismount){
     
    }

    },[videoitems]) */

    
    const stringify = (dgarray) =>{
        let ttg  = "";
        for(let i=0; i < dgarray.length; i++){

            if(i < dgarray.length-1){

                ttg+= dgarray[i].name+",";
            }else{
                ttg+= dgarray[i].name
            }   
        }
        return ttg;
    }

    const catObject= (dgarray) =>{
        let ttg  = [];
        for(let i=0; i < dgarray.length; i++){

            
                if(dgarray[i].parent != null){
                    
                    ttg[i] = {

                        "catname" : dgarray[i].name,
                        "catpath" : dgarray[i].parent.node.name +"/" + dgarray[i].name,
                    }
                    

                }else{
                    ttg[i] = {

                        "catname" : dgarray[i].name,
                        "catpath" : "./" + dgarray[i].name,
                    }

                }
                  
        }
        return ttg;
    }


   
  
    const observer = useRef();
   
    const itemRef = useCallback(node => {

        if (loading) {return <div>{ loading && <MyLoader /> }</div>}
        if(observer.current)observer.current.disconnect()

        observer.current = new IntersectionObserver(entries =>{

            if(entries[0].isIntersecting){

               
                 
    fetchMore({ variables: { categoryNotIn: catnotin, categoryName: pagemeta, first: 25, after: newsitems.endCursor }, updateQuery
      });
    
      items_more +=15;
             
            
            }
        })
        if(node) observer.current.observe(node)
    }, [loading, error, newsitems, items]);


    
    const time_ago = (datepublished) =>{
   
         var datepub = new Date(datepublished)
         var datecurrent = new Date()
         datecurrent = datecurrent.getTime()
 
         var datedif = datecurrent - (datepub.getTime());
 
         var tm = Math.floor(datedif / 60000);

         if(Math.floor(tm/(43200*12)) > 0){
 
            return Math.floor(tm/(43200*12)) + " years ago";

        }else if (Math.floor(tm/(1440*30)) > 0){
 
            return Math.floor(tm/(1440*30)) + " months ago";
        }else if(Math.floor(tm/(1440*7)) > 0){
 
            return (Math.floor(tm/(1440*7))) + " weeks ago";
        }else if(Math.floor(tm / 1440) > 0){
 
            return (Math.floor(tm/1440)) + " day ago"
        }else if(Math.floor(tm) > 60){
            let hrago = Math.floor (Math.floor(tm) / 60);
            let minago = Math.floor(tm - (hrago * 60))
            if(hrago > 24 ){

                return (Math.floor(hrago /24)) + " days ago"
            }
            return hrago + "hr " + minago + " min ago"

        }else if(Math.floor(tm) < 60){
 
            return Math.floor(tm) + " min ago"

        }else if(tm <= 0 ){
 
             return "Just Now"
 
         }
 
     }



    let n = 0;
   /* if(videoitems.error){

        console.log(videoitems.error)
    }*/
  //console.log(videoitems)
// if(loading){
      
//         return  <div style={{width:"100%"}}>{ loading && <MyLoader /> }</div>

// }


// //console.log(window.location.origin)
 
// if(error){

//         return <div style={{width:"100%"}}>{ error && "Error Loading News content Please try again later..." }</div>

// }

if(items.length > 0){

    return(
        <>

<Helmet>
  <meta charSet="utf-8" />
  <title>{(pg[1]).toUpperCase()}</title>
  </Helmet>
  <Chartbeat page={pagemeta} />
        {/* { shown === true &&

            <div style={{ position: "fixed",top: "79px", display:"block", width: "557px", zIndex: "300"}}> 
    <Link to={{pathname:"/" + pagemeta}} style={{display:"block", padding: "5px 15px", width: "181px", boxShadow: "0px 0px 10px #55555537", margin: "0px auto", backgroundColor: "#ff0000", color:"#ffffff", borderRadius:"5px" }}>New stories available</Link>
            
            </div>
       } */}
        
        <div style={{position: "relative",zIndex:"0",top:"0px"}}>

                <Sectionlead category={pagemeta} />
                {/* {(pagemeta != "newsfeed" & pagemeta != "" & pagemeta != null) ? <Sectionlead category={pagemeta} /> : <Topstory />} */}

           {/* <Mobilead /> */}
           {/* <Newstories cursor={newsitems.endCursor} fetchmore = {event => fetchMore} /> */}
            {/*<div style={{margin:"15px auto"}}>
                <GoogleAds slot="/1002554/Myjoyonline/myjoyonline_home_feed_top" id="myjoyonline_home_feed_top" />
            </div>*/}
        {
            
          
        items.length > 0 && ismount &&
        items.map((item, index) => {

               
            if(items.length === index+1 && item.node.featuredImage !== null){
                return (
                    <>
                        <FeedItem ref={itemRef} source={item.node.source} key={item.node.id} id={item.node.id} datepublished={time_ago(item.node.dateGmt)} title={item.node.title} image={item.node.featuredImage.node.sourceUrl} storyurl={item.node.slug+"/"} tags={item.node.tags.nodes} summary={item.node.excerpt} category={catObject(item.node.categories.nodes)}/> 
                        <div style={{textAlign: "center"}}><MyLoader /></div>
                    </>
                )
            }else if(items.length === index+1 && item.node.featuredImage == null){

                return (
                    <>
                        <FeedItem ref={itemRef} source={item.node.source} key={item.node.id} id={item.node.id} datepublished={time_ago(item.node.dateGmt)} title={item.node.title} storyurl={item.node.slug+"/"} tags={item.node.tags.nodes} summary={item.node.excerpt} category={catObject(item.node.categories.nodes)}/> 
                        <div style={{textAlign: "center"}}><MyLoader /></div>
                    </>
                    )
            } 

               //if((index+1) % 5 === 0 && item.node.featuredImage !== null){

                    
                    if(index > 0 && index % 3 === 0 && videoitems.length > 0  && item.node.featuredImage !== null ){
                        vindex++;
                 
                    return (
                        <>
                    <Video video={'https://www.youtube.com/watch?v='+videoitems[vindex].id.videoId} title={videoitems[vindex].snippet.title} vid={videoitems[vindex].id.videoId}  /> 
                    
                   {/* <FeedItem source={item.node.source} key={item.node.id} id={item.node.id} datepublished={time_ago(item.node.dateGmt)} title={item.node.title} image={item.node.featuredImage.node.sourceUrl} storyurl={item.node.slug+"/"} tags={item.node.tags.nodes} summary={item.node.excerpt} category={catObject(item.node.categories.nodes)}/> */}
                     </>
                      
                        )
                       
                 }

                    // return (
                    //     <FeedItem  source={item.node.source} key={item.node.id} id={item.node.id} title={item.node.title} datepublished={time_ago(item.node.dateGmt)} image={item.node.featuredImage.node.sourceUrl} storyurl={item.node.slug+"/"} tags={item.node.tags.nodes} summary={item.node.excerpt} category={catObject(item.node.categories.nodes)}/>
                    //     )

                //}

                if (item.node.featuredImage !== null){
                return(
                <>
               
                
                <FeedItem source={item.node.source} key={item.node.id} id={item.node.id} datepublished={time_ago(item.node.dateGmt)} title={item.node.title} image={item.node.featuredImage.node.sourceUrl} storyurl={item.node.slug+"/"} tags={item.node.tags.nodes} summary={item.node.excerpt} category={catObject(item.node.categories.nodes)}/>
               <Customad id={item.node.id} slot="/1002554/Myjoyonline/myjoyonline_home_feed_native" />
               
                    </>
                )
        }else{

            return(
                <>
               
                
                <FeedItem source={item.node.source} key={item.node.id} id={item.node.id} datepublished={time_ago(item.node.dateGmt)} title={item.node.title} storyurl={item.node.slug+"/"} tags={item.node.tags.nodes} summary={item.node.excerpt} category={catObject(item.node.categories.nodes)}/>
               <Customad id={item.node.id} slot="/1002554/Myjoyonline/myjoyonline_home_feed_native" />
               
                    </>
                )
        }
               
                        

}

    
)

}


</div>

</>
    );

}else{

    return(
    <div style={{textAlign: "center"}}>
        <MyLoader />
        </div>
        )
}
    
}

export default NewsFeed;